import Text from './Text';
import * as React from 'react';
export const Paragraph = (props) => {
    const { children, ...otherProps } = props;
    return (React.createElement(Text, Object.assign({ type: "paragraph" }, otherProps), children));
};
Paragraph.displayName = 'Paragraph';
export default Paragraph;
//# sourceMappingURL=Paragraph.js.map